(ns practitest.frontend.components.view-editor.schema
  (:require
    [practitest.frontend.common.re-frame :as rf-common]))

;; ---- schema ----

(def FormSchema
  [:map {:closed true}
   [:name {:optional true} :string]
   [:name-auto-generated? {:optional true} :boolean]
   [:public? {:optional true} :boolean]
   [:definition {:optional true} [:vector :string]]
   [:mode {:optional true} [:enum :ptql :auto-filter]]
   [:ancestors-path {:optional true}
    [:vector [:map [:id pos-int?] [:name :string]]]]
   [:ancestors-ptql-raw {:optional true} [:maybe :string]]
   [:ancestors-ptql-optimized {:optional true} [:maybe :string]]
   [:view-ptql {:optional true} :string]
   [:combined-ptql-raw {:optional true} [:maybe :string]]
   [:combined-ptql-optimized {:optional true} [:maybe :string]]
   [:view-ast {:optional true} [:maybe vector?]]
   [:basic-builder-ast {:optional true} [:maybe vector?]]
   [:auto-filter {:optional true} [:vector [:maybe :string]]]
   [:hide-empty-auto-filters {:optional true} :boolean]
   [:cross-filter-entity-by-path {:optional true} :map]])

(def EntityTypeSchema
  [:maybe [:enum "Test" "Issue" "Requirement" "TestSet"]])

(def AutoFilterOption
  [:map
   [:value :string]
   [:label :string]])

(def ViewEditorSchema
  [:map {:closed true}
   [:open? :boolean]
   [:mode {:optional true} [:enum :create :edit]]
   [:view-id {:optional true} [:maybe pos-int?]]
   [:parent-id {:optional true} [:maybe pos-int?]]
   [:entity-type {:optional true} EntityTypeSchema]
   [:loading? {:optional true} :boolean]
   [:saving? {:optional true} :boolean]
   [:recomputing? {:optional true} :boolean]
   [:error {:optional true} [:maybe :string]]
   [:ptql-error {:optional true} [:maybe :string]]
   [:auto-filter-options {:optional true} [:vector AutoFilterOption]]
   [:auto-filter-max-levels {:optional true} pos-int?]
   [:auto-filter-limit-reached? {:optional true} :boolean]
   [:available-fields {:optional true}
    [:vector [:map [:id :string] [:label :string]]]]
   [:cross-filter-modules {:optional true} [:vector :string]]
   [:cross-filter-urls {:optional true} [:maybe :map]]
   [:cross-filter-views {:optional true} :map]
   [:form {:optional true} FormSchema]
   [:filter-render-mode {:optional true} [:enum :basic :advanced]]
   [:seed {:optional true} [:maybe FormSchema]]])

;; ---- interceptors ----

(def event-interceptors
  (if ^boolean goog.DEBUG [(rf-common/mk-state-validator [:view-editor] ViewEditorSchema)] []))

